import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { formatCurrency, formatPercentage } from '@/utils/formatters';
import { TrendingUp } from 'lucide-react';

interface DashboardSummary {
  total_commitment: number;
  total_called: number;
  total_contributed: number;
  total_distributed: number;
  uncalled_commitment: number;
  net_contributions: number;
  nav: number | null;
  unrealized_gain_loss: number | null;
  base_currency: string | null;
}

interface KeyMetricsProps {
  summary: DashboardSummary;
}

export const KeyMetrics = ({ summary }: KeyMetricsProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Capital Called</CardTitle>
          <TrendingUp className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">
            {formatCurrency(summary.total_called, {
              currency: summary.base_currency,
            })}
          </div>
          <p className="text-xs text-muted-foreground">
            {summary.total_commitment > 0
              ? formatPercentage(
                  summary.total_called / summary.total_commitment
                )
              : formatPercentage(0)}{' '}
            of{' '}
            {formatCurrency(summary.total_commitment, {
              currency: summary.base_currency,
            })}{' '}
            commitment
          </p>
        </CardContent>
      </Card>
    </div>
  );
};
